export const getPublicUrl = (isTCSite: boolean) => {
  const url = isTCSite
    ? process.env.PUBLIC_URL_TC || 'https://www.tauilchequer.com.br'
    : process.env.PUBLIC_URL || 'https://www.mayerbrown.com';
  const publicUrl = url?.endsWith('/') ? url.slice(0, -1) : url;
  return publicUrl;
};
